/**
 * @description 分享到班级
 */

import { $location, updateUrlParameter } from '@umu/umu-dom';
import { ShareObjType } from '@umu/umu-types';

export interface IShareToClassPageParams {
    shareType: ShareObjType;
    shareId?: number; // 分享页面id，为图片时不需要
    picUrl?: string; // 分享图片或页面的url
    content?: string; // 用户分享留言
    objTitle?: string;
    objType?: string;
    objBanner?: string;
    objUserAvatar?: string;
}

function goToSharePage(params: IShareToClassPageParams) {
    const fromUrl = $location.href;
    return updateUrlParameter('/class/share-to-space', {
        share_type: params.shareType,
        share_id: params.shareId,
        pic_url: params.picUrl,
        obj_title: params.objTitle,
        obj_type: params.objType,
        obj_banner: params.objBanner,
        obj_user_avatar: params.objUserAvatar,
        from_url: fromUrl, // 回跳的url
    });
}

export default {
    goToSharePage,
};
